import http from 'hub-http/clients/apiClient';
import { CONTACTS } from '../constants/EarlyRequesterNames';
import getEarlyRequesterResult from './getEarlyRequesterResult';
const ENDPOINT = 'contacts/search/v1/search/contacts';
export function getContacts(isDevPortal = false) {
  // Dev portals will always return 403, instead return 0 and avoid sentry logging
  const isExpectedError = () => {
    if (isDevPortal) {
      return {
        total: 0
      };
    }
    return false;
  };
  const earlyRequest = getEarlyRequesterResult(CONTACTS, isExpectedError);
  const getContactsPromise = () => http.post(ENDPOINT, {
    query: {
      clienttimeout: 7000
    },
    data: {
      filterGroups: [],
      count: 0,
      sorts: []
    }
  });
  const earlyRequestWithRetry = earlyRequest ? earlyRequest.catch(() => getContactsPromise()) : null;
  return earlyRequestWithRetry || getContactsPromise();
}